import script from "./VocSetting.vue?vue&type=script&setup=true&lang=js"
export * from "./VocSetting.vue?vue&type=script&setup=true&lang=js"

import "./VocSetting.vue?vue&type=style&index=0&id=4300efa5&lang=css"

const __exports__ = script;

export default __exports__